import { formatAppDateTime, formatAppTime, APP_TZ_IANA } from '../../utils/appTimezone';

export function staffRoleSuffix(role) {
  if (role === 'head doctor') return 'Chef méd.';
  if (role === 'doctor') return 'Médecin';
  if (role === 'dentist') return 'Dentiste';
  if (role === 'nurse') return 'Infirmier(ière)';
  if (role === 'major') return 'Major';
  return role || '';
}


export function formatVisitDate(isoLike) {
  if (!isoLike) return '-';
  return formatAppDateTime(isoLike);
}

export function formatVisitTime(isoLike) {
  if (!isoLike) return '—';
  return formatAppTime(isoLike);
}

/** Affiche YYYY-MM-DD renvoyé par MySQL pour les stats. */
export function formatStatsServerDate(value) {
  if (value == null || value === '') return '';
  const s = String(value);
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : s.slice(0, 10);
}

export function consultStatusLabel(status) {
  if (status === 'PENDING') return 'En attente';
  if (status === 'COMPLETED') return 'Terminée';
  if (status === 'CANCELLED') return 'Annulée';
  return status || '-';
}

export function visitStatusLabel(status) {
  if (status === 'REGISTERED') return 'À orienter';
  if (status === 'ORIENTED') return 'Orienté(e)';
  return status || '-';
}

/** Âge au passage réception ; `ageYears` depuis l’API (TIMESTAMPDIFF année à la date de visite). */
export function formatReceptionAgeAtVisit(ageYears) {
  if (ageYears == null || ageYears === '') return '—';
  const n = typeof ageYears === 'number' ? ageYears : parseInt(String(ageYears), 10);
  if (Number.isNaN(n)) return '—';
  if (n < 1) return '< 1 an';
  if (n === 1) return '1 an';
  return `${n} ans`;
}

export function formatReceptionHeaderMs(epochMs, displayIanaTz) {
  try {
    const tz =
      displayIanaTz && typeof displayIanaTz === 'string' && displayIanaTz.trim().length > 0
        ? displayIanaTz.trim()
        : APP_TZ_IANA;
    const opts = {
      timeZone: tz,
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    };
    return new Intl.DateTimeFormat('fr-FR', opts).format(epochMs);
  } catch {
    return formatAppDateTime(epochMs);
  }
}
